/* global module:true document:true*/
/*eslint no-undef: "error"*/

import React from 'react'
import { render } from 'react-dom'
import ProductPage from './startup/ProductPage'

render(<ProductPage/>, document.getElementById('app'))

/*if (module.hot) {
  module.hot.accept('./startup/ProductPage', () => {
    const NextRootContainer = require('./startup/ProductPage').default
    render(<NextRootContainer/>, document.getElementById('app'))
  })
}*/
